const doc = [({"ja":({"task":"バッチ名", "aggregateDate":"基準日", "fromDate":"集計日(開始)", "toDate":"集計日(終了)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;